import React, { useRef, useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Button,
  Dialog,
  Typography,
  Autocomplete,
  TextField,
  Popper,
  Paper,
  List,
  ListItem,
  ListItemText,
  Stack,
  Grid2,
  IconButton,
  Drawer,
  InputAdornment,
  Tabs,
  Tab,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import { encryptData } from "../../utils/cryptoUtils";
import { jwtDecode } from "jwt-decode";
import ApplyLeave from "./ApplyLeave";
import {
  deleteLeave,
  getLeave,
  getLeaveByUserId,
  getUserLeaveDetail,
  updateLeave,
} from "../../services/leaveManagement.service";
import dayjs from "dayjs";
import { getTokenbyData, getUser } from "../../services/user.service";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import AvailableLeave from "../../components/LeaveManagement/AvailableLeave";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import CasualLeave_Icon from "../../assets/images/CasualLeave_Icon.svg";
import SickLeave_Icon from "../../assets/images/SickLeave_Icon.svg";
import EarnedLeave_Icon from "../../assets/images/EarnedLeave_Icon.svg";
import { DatePicker } from "antd";
import { useAuth } from "../../context/AuthProvider";

const { RangePicker } = DatePicker;

const LeaveManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const { canAdd, canEdit, canDelete } = usePermissions();
  const fromDashboard = location.state?.fromDashboard || false;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openAvailableDrawer, setOpenAvailableDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [openPass, setOpenPass] = useState(false);
  const [data, setData] = useState([]);
  const [userLeaveData, setUserLeaveData] = useState([]);
  const [who, setWho] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [leaveCount, setLeaveCount] = useState({});
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployeeId, setselectedEmployeeId] = useState(null);
  const [openLoader, setOpenLoader] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  // const currentDate = dayjs();
  // const formattedDate = currentDate.format("DD/MM/YYYY");
  const [userData, setUserData] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [queryParam, setQueryParam] = useState({
    date: null,
    startDate: null,
    endDate: null,
    type: "All",
    search: "",
    employee: "All",
    employeeId: "",
  });

  const [openPopper, setOpenPopper] = useState(false); // State to manage Popper visibility
  const anchorRef = useRef(null); // Reference for the element that triggers the popper
  const openLeave = () => {
    setOpenPopper(true);
  };
  const closeLeave = () => {
    setOpenPopper(false);
  };

  //decodeToken
  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const getData = async () => {
    try {
      const encryptedQueryParam = {
        startDate: queryParam.startDate,
        endDate: queryParam.endDate,
        type: encryptData(queryParam.type),
        search: encryptData(queryParam.search),
        employee: encryptData(queryParam.employee),
        employeeId: encryptData(queryParam.employeeId),
      };

      const res = await getLeave(encryptedQueryParam);
      const modifiedData =
        res?.data.data.map((e) => {
          return {
            ...e,
            name: e?.userData?.name,
            updatedByName: e?.updatedByName || "-",
            createdAt: dayjs(e?.createdAt).format("DD/MM/YYYY hh:mm A"),
            leaveDate: dayjs(e?.leaveDate).format("DD/MM/YYYY"),
            startDate: dayjs(e?.startDate).format("DD/MM/YYYY"),
            endDate: dayjs(e?.endDate).format("DD/MM/YYYY"),
            isReverted: e?.status === "Approved" ? true : false,
          };
        }) || [];
      setData(modifiedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const userId = getUserIdFromToken();
  // const userId = localStorage.getItem("_id");
  // const isOverAllAdmin = localStorage.getItem("isOverAllAdmin");
  // if (isOverAllAdmin == true) {
  //   setWho(true);
  // }
  const getUserLeaveData = async () => {
    try {
      const encryptedQueryParam = {
        startDate: queryParam.startDate,
        endDate: queryParam.endDate,
        type: encryptData(queryParam.type),
        search: encryptData(queryParam.search),
        employee: encryptData(queryParam.employee),
      };
      const res = await getLeaveByUserId(userId, encryptedQueryParam);
      const userleaveData =
        res?.data.data.map((e) => {
          return {
            ...e,
            name: e?.userData?.name,
            updatedByName: e?.updatedByName || "-",
            createdAt: dayjs(e?.createdAt).format("DD/MM/YYYY hh:mm A"),
            leaveDate: dayjs(e?.leaveDate).format("DD/MM/YYYY"),
            startDate: dayjs(e?.startDate).format("DD/MM/YYYY"),
            endDate: dayjs(e?.endDate).format("DD/MM/YYYY"),
            isReverted: e?.status === "Approved" ? true : false,
          };
        }) || [];
      setUserLeaveData(userleaveData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const res = await getUser({ isEnabled: true });
        const configData = res.data.data.map((e) => ({
          ...e,
          label: e.name,
        }));
        setEmployeeData(configData);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployeeData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTokenbyData();
        console.log("www", res);
        const usersData = res.data;
        const isAdmin = usersData?.isOverAllAdmin || false;
        console.log("API call", isAdmin);
        setWho(isAdmin);
        if (isAdmin) {
          await getData(queryParam);
        }
        if (!isAdmin) {
          await getUserLeaveData(userId, queryParam);
        }
        setOpenLoader(false);
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchData();
  }, [
    userId,
    deleteFlag,
    queryParam.date,
    queryParam.search,
    queryParam.type,
    queryParam.employee,
    queryParam.startDate,
    queryParam.endDate,
  ]);

  // useEffect(() => {
  //   getData();
  //   getUserLeaveData(userId);
  // }, [userId]);

  const getUserLeaveDetailData = async (userId) => {
    try {
      const res = await getUserLeaveDetail(userId);
      const configData = res?.data;
      setLeaveCount(configData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserLeaveDetailData(userId);
  }, [userId, deleteFlag]);

  const getUserData = async () => {
    try {
      const res = await getUser();
      const configData = res.data.data
        .filter((e) => !e.isOverAllAdmin)
        .map((e) => {
          return {
            ...e,
            label: `${e.firstName} ${e.lastName}`,
          };
        });
      configData.unshift({ _id: "All", name: "All", label: "All" });
      setUserData(configData);
      console.log("ccc", configData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  const LeaveType = [
    { label: "All", name: "All" },
    { label: "Approved", name: "Approved" },
    { label: "Pending", name: "Pending" },
    { label: "Rejected", name: "Rejected" },
    { label: "Reverted", name: "Reverted" },
  ];

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
    setOpenPass(true);
  };

  const handleAvailable = (e) => {
    setOpenAvailableDrawer(true);
    setSelectedData(e);
  };
  // const handleUpdate = async (e) => {
  //   e.isView = true;
  //   setOpenDrawer(true);
  //   setSelectedData(e);
  // }

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const handleDelete = async (e) => {
    try {
      const userId = getUserIdFromToken();
      // const userId = localStorage.getItem("_id");
      const res = await deleteLeave(e._id, {
        leaveDayId: e.leaveDayId,
        userId: userId,
      });
      ToastError(res.message);

      setData((prevLeaves) =>
        prevLeaves.filter((leave) => leave._id !== e._id)
      );
      setUserLeaveData((preLeave) =>
        preLeave.filter((leave) => leave._id !== e._id)
      );
      setDeleteFlag((prevFlag) => !prevFlag);
    } catch (error) {
      ToastError(error.data.message);
    }
  };

  const handleApprove = (e) => {
    const data = {
      status: "Approved",
    };
    updateLeave(e._id, data, { leaveDayId: e.leaveDayId }).then(() => {
      ToastSuccess("Approved");
      if (who) {
        getData();
      } else {
        getUserLeaveData();
      }
    });
  };
  const handleRevert = (e) => {
    const data = {
      status: "Reverted",
    };
    updateLeave(e._id, data, { leaveDayId: e.leaveDayId })
      .then(() => {
        ToastSuccess("Reverted");
        if (who) {
          getData();
        } else {
          getUserLeaveData();
        }
      })
      .catch((error) => {
        ToastError(error?.data?.message);
      });
  };
  const handleReject = (e) => {
    const data = {
      status: "Rejected",
    };
    updateLeave(e._id, data, { leaveDayId: e.leaveDayId }).then(() => {
      ToastSuccess("Rejected");
      if (who) {
        getData();
      } else {
        getUserLeaveData();
      }
    });
  };

  if (openLoader) {
    // return <CommonLoader />; // Show loading text or spinner
    return (
      <Typography>
        <CommonLoader />
      </Typography>
    );
  }
  let columns;

  if (who === true) {
    columns = [
      { id: "createdAt", label: "Request Date & Time" },
      { id: "name", label: "Name" },
      { id: "leaveType", label: "Leave Type" },
      { id: "reason", label: "Leave Reason" },
      { id: "leaveDate", label: "Leave Date" },
      { id: "leaveDayType", label: "Leave" },
    ];
    if (activeTab === "Rejected") {
      columns.push({ id: "rejectionReason", label: "Rejection Reason" });
    }
    if (activeTab === "All") {
      columns.push({ id: "status", label: "Status" });
    }
    // Add Updated By column for Approved, Rejected, Reverted, and All tabs
    if (["Approved", "Rejected", "Reverted", "All"].includes(activeTab)) {
      columns.push({ id: "updatedByName", label: "Updated By" });
    }
  } else {
    columns = [
      { id: "createdAt", label: "Date" },
      { id: "leaveType", label: "Leave Type" },
      { id: "reason", label: "Leave Reason" },
      { id: "leaveDate", label: "Leave Date" },
      { id: "leaveDayType", label: "Leave" },
    ];
    if (activeTab === "Rejected") {
      columns.push({ id: "rejectionReason", label: "Rejection Reason" });
    }
    // Add Updated By column for Approved, Rejected, Reverted, and All tabs
    if (["Approved", "Rejected", "Reverted", "All"].includes(activeTab)) {
      columns.push({ id: "updatedByName", label: "Updated By" });
    }
    if (activeTab === "All") {
      columns.push({ id: "status", label: "Status" });
    }
  }


  const tableConfig = {
    isMore: true,
    isAction: true,
    isAdmin: true,
    // isDelete: true,
    isMore: true,
    isApprove: who === true,
    isReject: who === true,
    isRevert: who === true,
    isAvailableLeave: who === true,
  };

  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content", padding: { xs: "0px", md: "0" } }}>
        {/* Tabs Section - At the very top */}
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, display: { xs: "none", md: "block" } }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => {
              setActiveTab(newValue);
              setQueryParam({ ...queryParam, type: newValue });
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 500,
                color: "#666",
              },
              "& .Mui-selected": {
                color: "#008080 !important",
              },
              "& .MuiTabs-indicator": {
                backgroundColor: "#008080",
              },
            }}
          >
            <Tab label="All" value="All" />
            <Tab label="Pending" value="Pending" />
            <Tab label="Approved" value="Approved" />
            <Tab label="Rejected" value="Rejected" />
            <Tab label="Reverted" value="Reverted" />
          </Tabs>
        </Box>

        {/* Filters Row - Desktop Only */}
        <Grid
          container
          spacing={{ xs: 2, sm: 2 }}
          sx={{
            display: { xs: "none", md: "flex" },
            mb: 3
          }}
        >
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              placeholder="Search..."
              fullWidth
              size="small"
              onChange={(e) => handleSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon sx={{ color: "#9CA3AF" }} />
                  </InputAdornment>
                ),
              }}
              sx={{ bgcolor: "white" }}
            />
          </Grid>
          {who === true && (
            <Grid item xs={12} sm={6} md={2.5}>
              <Autocomplete
                value={employeeData.find((e) => e._id === selectedEmployeeId) || null}
                options={employeeData}
                onChange={(e, v) => {
                  setselectedEmployeeId(v?._id);
                  setQueryParam({ ...queryParam, search: v?.name === "All" || !v ? "" : v.name });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Employee"
                    size="small"
                    sx={{ bgcolor: "white" }}
                  />
                )}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={who === true ? 4.5 : 7}>
            <RangePicker
              value={queryParam?.date || null}
              onChange={(date) => {
                if (date && Array.isArray(date)) {
                  setQueryParam({
                    ...queryParam,
                    date,
                    startDate: date[0],
                    endDate: date[1],
                  });
                } else {
                  setQueryParam({
                    ...queryParam,
                    date: null,
                    startDate: null,
                    endDate: null,
                  });
                }
              }}
              className="w-100"
              style={{ height: "40px" }}
            />
          </Grid>

          {who === false && (
            <Grid item xs={12} sm={6} md={2} sx={{ display: { xs: "none", md: "block" } }}>
              <PermissionGate module="leaveManagement" action="add">
                <Button
                  startIcon={<AddOutlinedIcon />}
                  onClick={() => handleAdd()}
                  variant="contained"
                  sx={{
                    bgcolor: "#008080",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    width: "100%",
                    "&:hover": {
                      bgcolor: "#006666",
                    }
                  }}
                >
                  Apply Leave
                </Button>
              </PermissionGate>
            </Grid>
          )}
        </Grid >
      </Box >
      {who === false && (
        <Grid2
          container
          spacing={2}
          mt={{ xs: 0, sm: 2 }}
        >
          {/* Planned Leave Card */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Box
              sx={{
                bgcolor: "#FFFFFF",
                borderRadius: "16px",
                p: 1.5,
                border: "1px solid #F2F4F7",
                boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0px 12px 28px -8px rgba(16, 24, 40, 0.08), 0px 8px 12px -6px rgba(16, 24, 40, 0.03)",
                  borderColor: "#A7F3D0"
                }
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#ECFDF5",
                    color: "#059669"
                  }}
                >
                  <Box
                    component="img"
                    src={CasualLeave_Icon}
                    alt="Planned Leave"
                    sx={{ width: 22, height: 22 }}
                  />
                </Box>
                <Stack>
                  <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#6B7280", mb: 0 }}>
                    Planned Leave
                  </Typography>
                  <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
                    {leaveCount?.availableLeave?.plannedLeave || 0}
                    <Typography component="span" sx={{ fontSize: "12px", color: "#9CA3AF", fontWeight: 500, ml: 0.5 }}>
                      Days
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Grid2>

          {/* Unplanned Leave Card */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Box
              sx={{
                bgcolor: "#FFFFFF",
                borderRadius: "16px",
                p: 1.5,
                border: "1px solid #F2F4F7",
                boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0px 12px 28px -8px rgba(16, 24, 40, 0.08), 0px 8px 12px -6px rgba(16, 24, 40, 0.03)",
                  borderColor: "#BAE6FD"
                }
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#EFF6FF",
                    color: "#2563EB"
                  }}
                >
                  <Box
                    component="img"
                    src={SickLeave_Icon}
                    alt="Unplanned Leave"
                    sx={{ width: 22, height: 22 }}
                  />
                </Box>
                <Stack>
                  <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#6B7280", mb: 0 }}>
                    Unplanned Leave
                  </Typography>
                  <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
                    {leaveCount?.availableLeave?.unplannedLeave || 0}
                    <Typography component="span" sx={{ fontSize: "12px", color: "#9CA3AF", fontWeight: 500, ml: 0.5 }}>
                      Days
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Grid2>

          {/* Earned Leave Card */}
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <Box
              sx={{
                bgcolor: "#FFFFFF",
                borderRadius: "16px",
                p: 1.5,
                border: "1px solid #F2F4F7",
                boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                cursor: "pointer",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0px 12px 28px -8px rgba(16, 24, 40, 0.08), 0px 8px 12px -6px rgba(16, 24, 40, 0.03)",
                  borderColor: "#FDE68A"
                }
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#FFFBEB",
                    color: "#D97706"
                  }}
                >
                  <Box
                    component="img"
                    src={EarnedLeave_Icon}
                    alt="Earned Leave"
                    sx={{ width: 22, height: 22 }}
                  />
                </Box>
                <Stack>
                  <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#6B7280", mb: 0 }}>
                    Earned Leave
                  </Typography>
                  <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
                    {leaveCount?.availableLeave?.earnedLeave || 0}
                    <Typography component="span" sx={{ fontSize: "12px", color: "#9CA3AF", fontWeight: 500, ml: 0.5 }}>
                      Days
                    </Typography>
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          </Grid2>
        </Grid2>
      )}

      {/* Mobile Top Buttons (Conditionally rendered below cards for better layout) */}
      <Box sx={{ display: { xs: "flex", md: "none", justifyContent: "space-between" }, gap: 1.5, mt: 1.5, mb: 2 }}>
        <Button
          variant={showFilters ? "contained" : "outlined"}
          onClick={() => setShowFilters(!showFilters)}
          sx={{
            minWidth: "48px",
            width: "48px",
            height: "48px",
            padding: 0,
            borderColor: "#E5E7EB",
            borderRadius: "12px",
            color: showFilters ? "#fff" : "#6B7280",
            backgroundColor: showFilters ? "#008080" : "#FFFFFF",
            "&:hover": {
              borderColor: "#D1D5DB",
              backgroundColor: showFilters ? "#006666" : "#F9FAFB",
            }
          }}
        >
          {showFilters ? <CloseIcon /> : <FilterListIcon />}
        </Button>

        {who === false && (
          <PermissionGate module="leaveManagement" action="add">
            <Button
              variant="contained"
              startIcon={<AddOutlinedIcon />}
              onClick={() => handleAdd()}
              className="Add-Button"
              sx={{
                flex: 1,
                borderRadius: "12px",
                py: 1.2,
                textTransform: "none",
                fontWeight: 600,
                fontSize: "15px",
                bgcolor: "#008080",
                "&:hover": {
                  bgcolor: "#006666"
                }
              }}
            >
              Apply Leave
            </Button>
          </PermissionGate>
        )}
      </Box>

      {/* Mobile Filters Drawer (Action Sheet Style) */}
      <Drawer
        anchor="bottom"
        open={showFilters}
        onClose={() => setShowFilters(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            padding: "28px",
            maxHeight: "80vh"
          }
        }}
      >
        <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}>
            Filter Requests
          </Typography>
          <IconButton onClick={() => setShowFilters(false)} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                bgcolor: "#FFFFFF",
                borderRadius: "8px",
                border: "1px solid #E5E7EB",
                px: 2,
                height: "48px"
              }}
            >
              <SearchOutlinedIcon sx={{ color: "#9CA3AF", mr: 1.5 }} />
              <input
                style={{
                  border: "none",
                  outline: "none",
                  width: "100%",
                  fontSize: "18px",
                  color: "#111827",
                  background: "transparent"
                }}
                placeholder="Search..."
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Autocomplete
              options={LeaveType}
              disableClearable={true}
              value={LeaveType.find((option) => option.name === queryParam.type) || null}
              onChange={(e, v) => {
                setQueryParam({ ...queryParam, type: v ? v.name : queryParam.type });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Status"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      bgcolor: "#FFFFFF",
                      height: "48px",
                      fontSize: "18px",
                      "& fieldset": { borderColor: "#E5E7EB" },
                      "&.Mui-focused fieldset": { borderColor: "#008080" }
                    }
                  }}
                />
              )}
            />
          </Grid>
          {who === true && (
            <Grid item xs={12}>
              <Autocomplete
                value={employeeData.find((e) => e._id === selectedEmployeeId) || null}
                options={employeeData}
                onChange={(e, v) => {
                  setselectedEmployeeId(v?._id);
                  setQueryParam({ ...queryParam, search: v?.name === "All" || !v ? "" : v.name });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Employee"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        bgcolor: "#FFFFFF",
                        height: "48px",
                        fontSize: "18px",
                        "& fieldset": { borderColor: "#E5E7EB" },
                        "&.Mui-focused fieldset": { borderColor: "#008080" }
                      }
                    }}
                  />
                )}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <RangePicker
              value={queryParam?.date || null}
              onChange={(date) => {
                if (date && Array.isArray(date)) {
                  setQueryParam({
                    ...queryParam,
                    date,
                    startDate: date[0],
                    endDate: date[1],
                  });
                } else {
                  setQueryParam({
                    ...queryParam,
                    date: null,
                    startDate: null,
                    endDate: null,
                  });
                }
              }}
              getPopupContainer={(trigger) => document.body}
              dropdownClassName="high-z-index-datepicker"
              popupClassName="high-z-index-datepicker"
              style={{
                height: "48px",
                borderRadius: "8px",
                border: "1px solid #E5E7EB",
                background: "#FFFFFF",
                width: "100%"
              }}
              popupStyle={{ zIndex: 99999 }}
            />
          </Grid>

          <Grid item xs={12} mt={2}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setShowFilters(false)}
              sx={{
                bgcolor: "#008080",
                borderRadius: "8px",
                height: "48px",
                textTransform: "none",
                fontSize: "16px",
                "&:hover": { bgcolor: "#006666" }
              }}
            >
              Show Results
            </Button>
          </Grid>
        </Grid>
      </Drawer>
      {
        who === true ? (
          // <div style={{ height: "80vh", overflow: "auto" }}>
          <MasterCommonTable
            tableConfig={tableConfig}
            data={data}
            columns={columns}
            handleApprove={handleApprove}
            handleRevert={handleRevert}
            handleReject={handleReject}
            handleAvailable={handleAvailable}
            handleDelete={handleDelete}
          // handleEdit={handleEdit}
          // handleView={handleView}
          // handleToggle={handleToggle}
          // tableTotalCount={tableTotalCount}
          />
        ) : (
          // </div>
          // <div style={{ height: "80vh", overflow: "auto" }}>
          <MasterCommonTable
            tableConfig={tableConfig}
            data={userLeaveData}
            columns={columns}
            // handleEdit={handleEdit}
            // handleView={handleView}
            // handleToggle={handleToggle}
            handleDelete={handleDelete}
            handleRevert={handleRevert}
            maxSetHeight={true}
          // tableTotalCount={tableTotalCount}
          />
          // </div>
        )
      }
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <ApplyLeave
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            openPass={openPass}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getUserLeaveData}
            GetLeaveData={getUserLeaveDetailData}
          />
        ) : null}
      </Dialog>
      <Dialog
        open={openAvailableDrawer}
        onClose={() => setOpenAvailableDrawer(false)}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        {openAvailableDrawer ? (
          <AvailableLeave
            selectedData={selectedData}
            setOpenDrawer={setOpenAvailableDrawer}
          />
        ) : null}
      </Dialog>
    </div >
  );
};
export default LeaveManagement;
